import React, { useEffect, useState } from "react";
import { useSnackBar } from "../../../../../../../../hooks/useSnackBar";
import "../../../../../../../../styles/shared/approve-payment.css";

// components imports
import Loader from "../../../../../../../../Components/CircularLoader/CircularLoader";

// library imports
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";

import { updateLTlBalance } from "../../../../../../../../services/ShipperServices/Payments/payments.services";
import { useTranslation } from "react-i18next";

export default function ApprovePayment({
  open,
  setOpen,
  setSnack: setSnackProp,
  setRefresh,
  previousData,
}) {
  const { t } = useTranslation("finances");
  // Several callers don't pass setSnack; without the fallback the error path throws.
  const notify = useSnackBar();
  const setSnack = setSnackProp || notify;
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleSave = async () => {
    setLoading(true);
    const response = await updateLTlBalance(previousData?.id);
    if (!response.error) {
      setLoading(false);
      setRefresh(Math.floor(Math.random() * 100) + 1);
      handleClose();
    } else {
      setLoading(false);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="apprv__payment_modal">
          <div className="apprv__payment_modalheading">{t("ltl.approvePayment")}</div>
          <div className="apprv__payment_modalcontent">
            <div className="apprv__payment_modalrow">
              <div className="apprv__payment_modalinputwrap">
                {t("ltl.amountPaid")} {previousData?.balance}
              </div>
            </div>
            <div className="apprv__payment_modalfooter">
              <div className="apprv__payment_modalcncl" onClick={handleClose}>
                {t("common:actions.cancel")}
              </div>
              <div
                className={`apprv__payment_modalsave ${
                  loading && "add__vehmodal_savedisabled"
                }`}
                onClick={handleSave}
              >
                {loading ? <Loader /> : t("common:actions.save")}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
